<template>
  <Dashboard grafana-path="/d/yofW6suMk/feedback-weekly-dashboard" />
</template>

<script>
// @ is an alias to /src
import Dashboard from "@/components/Dashboard.vue";

export default {
  name: "CustomerFeedbackPage",

  routing: {
    localizationKey: "menu.tab.customer_feedback",
    icon: "mdi-table-large",
    path: "/customer_feedback",
    hasAccess: (user) => user.isAdmin || user.isManager,
  },

  components: {
    Dashboard,
  },
};
</script>
